@if (mapDataIsLoading()) {
    <div class="list-loading">
        <ev-logo-loader width="70px" label="Henter prosjekter" />
    </div>
} @else {
    @if (sortedProjects().length > 0) {
        <div class="sort-wrapper">
            <div class="header">Sorter på</div>
            <div class="drop-down-wrapper">
                <ev-dropdown
                    [items]="sortOptions"
                    [selected]="sortKey()"
                    [variant]="'white'"
                    [minWidth]="'240'"
                    [height]="'30px'"
                    [variant]="'white'"
                    [zIndex]="10"
                    [right]="'-4px'"
                    (onSelected)="setSortKey($event)"
                ></ev-dropdown>
            </div>
        </div>
    }

    <div class="list-scroll-container">
        @for(project of sortedProjects(); track project.projectId) {
        <new-dwelling-stage-item [projectStage]="project"></new-dwelling-stage-item>
        }
    </div>
}
